/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Estes_ReadyInputs */

const en_orders_no_estes_ready = /** @type {(inputs: Orders_No_Estes_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No supported LTL-ready orders selected`)
};

const es_orders_no_estes_ready = /** @type {(inputs: Orders_No_Estes_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay pedidos LTL compatibles listos seleccionados`)
};

/**
* | output |
* | --- |
* | "No supported LTL-ready orders selected" |
*
* @param {Orders_No_Estes_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_estes_ready = /** @type {((inputs?: Orders_No_Estes_ReadyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Estes_ReadyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_estes_ready(inputs)
	return es_orders_no_estes_ready(inputs)
});